import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface LoaderState {   
    isInProgress: boolean;
  }
  
const initialState: LoaderState = {   
    isInProgress: false
  };


export class LoaderStateServiceForRoot extends StateService<LoaderState>{
    public static service: LoaderStateServiceForRoot;

    public static getLoaderStateService() : LoaderStateServiceForRoot {
        if ( this.service === undefined) {
            this.service = new LoaderStateServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<LoaderState> {
        return this.subscribe();
    }

    public changeLoaderState(load: LoaderState) : void {
        this.changeState(load);
    }

    public get state(): LoaderState {
        return this.state;
    }
}